<div class="row col-md-12">
    <div class="col-md-6">
        <label>Provincia</label>
        <select
            class="form-control"
            id="provincia"
            [(ngModel)]="provincia_corrente_id"
        >
            <option
                *ngFor="let p of province_toscane"
                [value]="p.id"
            >{{p.nome}}</option>
        </select><br>
    </div>
    <div class="col-md-6">
        <label>Comune</label>
        <select
            class="form-control"
            id="comune"
            [(ngModel)]="comune_corrente_id"
        >
            <option
                *ngFor="let c of comuni_filtered"
                [value]="c.id"
            >{{c.nome}}</option>
        </select><br>
    </div>
</div>
<div
    *ngIf="comune_corrente_id"
    class="row col-md-12"
>
    <nb-card
        *ngIf="consultori?.length > 0"
        class="col-md-4"
    >
        <nb-card-header>Consultori</nb-card-header>
        <nb-card-body>
            <nb-card
                *ngFor="let c of consultori"
                (click)="openDettaglioStruttura(c)"
            >
                <div class="modal-header">{{c.nome.it}}</div>
                <div class="modal-body"><i>{{c.indirizzo}}</i></div>
                <div class="row modal-body">
                    <div class="col-md-12">
                        Telefono: <b>{{c.telefono? c.telefono : 'Non disponibile'}}</b>
                    </div>
                    <div class="col-md-12">
                        Email: <b>{{c.email? c.email : 'Non disponibile'}}</b>
                    </div>
                </div>
            </nb-card>
        </nb-card-body>

    </nb-card>
    <nb-card
        *ngIf="punti_nascita?.length > 0"
        class="col-md-4"
    >
        <nb-card-header>Punti nascita</nb-card-header>
        <nb-card-body>
            <nb-card
                *ngFor="let p of punti_nascita"
                class="clickable"
                (click)="openDettaglioStruttura(p)"
            >

                <div class="modal-header">{{p.nome.it}}</div>
                <div class="modal-body"><i>{{p.indirizzo}}</i></div>
                <div class="row modal-body">
                    <div class="col-md-12">
                        Telefono: <b>{{p.telefono? p.telefono : 'Non disponibile'}}</b>
                    </div>
                    <div class="col-md-12">
                        Email: <b>{{p.email? p.email : 'Non disponibile'}}</b>
                    </div>
                </div>
            </nb-card>
        </nb-card-body>

    </nb-card>
    <nb-card
        *ngIf="ospedali_pediatrici?.length > 0"
        class="col-md-4"
    >
        <nb-card-header>Ospedale pediatrico regionale</nb-card-header>
        <nb-card-body>
            <nb-card
                *ngFor="let o of ospedali_pediatrici"
                (click)="openDettaglioStruttura(o)"
            >
                <div class="modal-header">{{o.nome.it}}</div>
                <div class="modal-body"><i>{{o.indirizzo}}</i></div>
                <div class="row modal-body">
                    <div class="col-md-12">
                        Telefono: <b>{{o.telefono? o.telefono : 'Non disponibile'}}</b>
                    </div>
                    <div class="col-md-12">
                        Email: <b>{{o.email? o.email: 'Non disponibile'}}</b>
                    </div>
                </div>
            </nb-card>
        </nb-card-body>
    </nb-card>
</div>
